import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { AREAS, SCOPES } from '../helpers/scopesRolesAreas';

const PermissionsContext = createContext();

const userHasPermissionToScope = (scopes, permissions) => {
	// Permissions  === what the user has for permissions
	// Scopes       === what is needed for access
	const generalAccessAreas = [AREAS.DASHBOARD, AREAS.PROFILE, AREAS.SETTINGS];

	if (permissions.includes(`${AREAS.ALL}:${SCOPES.ALL}`)) {
		return true;
	}

	let hasPermission = false;

	permissions.map((permission) => {
		const permissionArea = permission.split(':')[0];
		const permissionScope = permission.split(':')[1];

		return scopes.map((scope) => {
			const aArea = scope.split(':')[0];
			const aScope = scope.split(':')[1];

			if (generalAccessAreas.includes(aArea)) {
				hasPermission = true;
			}

			if (permissionArea === aArea) {
				if (permissionScope === SCOPES.ALL) {
					hasPermission = true;
				}

				if (permissionScope === aScope) {
					hasPermission = true;
				}
			}
		});
	});

	return hasPermission;
};

const PermissionsContextProvider = ({ children }) => {
	/* ====================== HOOKS ====================== */
	const { hasBeenLoaded, user } = useSelector((state) => state.userSlice);
	const { isAuthed } = useSelector((state) => state.authSlice);

	/* ====================== VALIDATOR ====================== */
	/* ====================== EFFECTS ====================== */
	useEffect(() => {}, [hasBeenLoaded]);

	/* ====================== METHODS ====================== */
	const userHasAccess = (scope) => {
		if (hasBeenLoaded) {
			const granted = userHasPermissionToScope(scope, user.role.permissions);
			return granted;
		}

		return false;
	};

	/* ====================== MEMO ====================== */
	const value = useMemo(
		() => ({
			userHasAccess
		}),
		[hasBeenLoaded]
	);

	if (!hasBeenLoaded && isAuthed) {
		return null;
	}

	/* ====================== RENDER ====================== */
	return (
		<PermissionsContext.Provider value={value}>
			{children}
		</PermissionsContext.Provider>
	);
};

PermissionsContextProvider.propTypes = {
	children: PropTypes.object
};

export const PermissionsProvider = withTranslation()(
	PermissionsContextProvider
);

export const usePermissions = () => {
	return useContext(PermissionsContext);
};
